import React from 'react';

import { useFlag } from 'utils/launchdarkly';

import { CookieBannerContainer as DefaultCookieBannerContainer } from './default-cookie-banner';
import { OneTrustCookieBanner } from './one-trust-cookie-banner';

export function CookieBannerContainer() {
  const enableCookieBanner = useFlag('enable-cookie-banner');
  const enableOneTrustCookieBanner = useFlag(
    'enable-one-trust-cookie-consent-banner'
  );

  if (enableCookieBanner) {
    return <DefaultCookieBannerContainer />;
  }

  if (enableOneTrustCookieBanner) {
    return <OneTrustCookieBanner />;
  }

  return null;
}
